export default "__VITE_ASSET__CUxnIs4S__"